import { tr as __tr, useLocale as __useLocale, direction as __direction, localizedField as __localizedField } from "../i18n/runtime";
import React from 'react';
import { Search, Shield, Headphones, Tag } from 'lucide-react';
import { whyChooseUs } from '../data/mockData';
const WhyChooseUs = () => {
  __useLocale();
  const getIcon = iconName => {
    const icons = {
      search: Search,
      shield: Shield,
      headphones: Headphones,
      tag: Tag
    };
    const IconComponent = icons[iconName] || Search;
    return <IconComponent className="w-8 h-8" />;
  };
  const getGradient = index => {
    const gradients = ['from-purple-500 to-indigo-600', 'from-emerald-500 to-teal-600', 'from-orange-500 to-red-500', 'from-blue-500 to-cyan-600'];
    return gradients[index % gradients.length];
  };
  return <section className="py-20 px-4 bg-gradient-to-br from-gray-50 to-gray-100" dir={__direction()}>
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-purple-100 text-[#6B5B95] px-4 py-2 rounded-full mb-4">
            <span className="text-xl">💡</span>
            <span className="font-medium">{__tr("لماذا الرحلة؟")}</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">{__tr(" جرب مستقبل حجوزات السفر ")}</h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">{__tr(" مع منصتنا المتطورة ")}</p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {__tr(whyChooseUs.map((feature, index) => <div key={feature.id} className="group bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 relative overflow-hidden">
              {/* Background decoration */}
              <div className={`absolute top-0 right-0 w-32 h-32 bg-gradient-to-br ${getGradient(index)} opacity-5 rounded-full transform translate-x-10 -translate-y-10 group-hover:scale-150 transition-transform duration-500`}></div>
              
              {/* Icon */}
              <div className={`inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br ${getGradient(index)} text-white mb-5 shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                {__tr(getIcon(feature.icon))}
              </div>

              {/* Title */}
              <h3 className="text-xl font-bold text-gray-800 mb-3">
                {__tr(feature.title)}
              </h3>

              {/* Description */}
              <p className="text-gray-600 text-sm leading-relaxed mb-4">
                {__tr(feature.description)}
              </p>

              {/* Badge */}
              {__tr(feature.badge && <div className="inline-flex items-center gap-1 bg-gray-100 text-gray-700 px-3 py-1.5 rounded-full text-xs font-medium">
                  <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
                  {__tr(feature.badge)}
                </div>)}
            </div>))}
        </div>
      </div>
    </section>;
};
export default WhyChooseUs;
